// components/ApproachSection.jsx
import SectionReveal from './SectionReveal';

export default function ApproachSection({ t }) {
  return (
    <section id="approach" className="relative bg-white px-6 py-6 md:px-10 shadow-nwta">
      
      <div className="mx-auto max-w-7xl">
        
        <SectionReveal>
          <div className="flex items-start gap-8 p-3 md:p-10 md:border-l-4 border-l-2 border-[#0FA4E8] bg-gray-50">
            
            <div className="flex-1">
              <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-4">
                {t?.approachTitle || 'Մեր մոտեցումը'}
              </h2>
              <p className="text-lg md:text-xl font-bold text-[#0B3B6F] mb-3">
                {t?.approachSubtitle || 'Մենք չենք վաճառում պարզապես սարքավորումներ։'}
              </p>
              <p className="text-base text-slate-600 leading-relaxed">
                {t?.approachDesc || 'Մենք ուսումնասիրում ենք յուրաքանչյուր նախագծի առանձնահատկությունները, գնահատում ենք տեխնիկական և բնապահպանական պահանջները և առաջարկում ենք այնպիսի լուծումներ, որոնք ապահովում են արդյունավետություն, հուսալիություն և երկարաժամկետ արդյունք։'}
              </p>
            </div>

          </div>
        </SectionReveal>

      </div>
    </section>
  );
}